import React from 'react';
import { Formik, Field } from "formik";

const Checkbox = (props) =>  {
  return (
      <Field name={props.name}>
        {({ field, form }) => (
            <span>
              <label htmlFor="overviewEnabled">
              <input
                  type="checkbox"
                  {...props}
                  checked={field.value === true}
                  onChange={() => { form.setFieldValue(props.name, !field.value );

                  }}
              /> { props.label }{" "}
                { props.hint && <span>{ props.hint }</span> }
              </label>

            </span>
        )}
      </Field>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js